export const ODOS_API_BASE_URL = 'https://api.odos.xyz';
export const ODOS_REFERRAL_CODE = 1701778763;
